export default __webpack_public_path__ + "54dbfd2ae5c2865cc27672a216fc4959.png";